import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {requestSurvey} from '../../actions/action_survey';
import Loader from '../Loader';
import Title from '../Title';
import Alert from '../Alert';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';
import ShareChannels from './share/ShareChannels';

class SurveyShare extends Component {
    componentDidMount() {
        this.props.requestSurvey(this.props.match.params.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.requestSurvey(this.props.match.params.id);
        }
    }

    renderContent(item, loading) {
        return (
            <div className="row survey-export">
                <div className="col-md-2 col-12 d-print-none">
                    <Link className="navbar-brand" to="/surveys">
                        <button type="button" className="btn btn-outline-primary btn-sm">
                            <Icon icon="arrow_left" /> <FormattedMessage {...messages.buttons.back} />
                        </button>
                    </Link>
                </div>
                <div className="col-md-8 col-12 col-print-12">
                    <Title>{item && item.name}</Title>
                    {loading && <Loader overlay={!!(item)} />}
                    {item && <ShareChannels survey={item} />}
                </div>
            </div>
        );
    }

    render() {
        const {item, loading, error} = this.props;
        return (error && <Alert error={error} /> || this.renderContent(item, loading, error));
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.survey.item,
        loading: state.survey.loading,
        error: state.survey.error,
    };
};

export default connect(mapStateToProps, {requestSurvey})(SurveyShare);
